<div class="row my-row justify-content-md-center" style="padding-top: 40px;">
    <div class="col-sm-auto">
        <div class="card" style="width: 70rem; border-radius: 20px; margin: 20px;">
            <div class="card-header text-center">
                <h1>{{ "OTP.TITLE" | translate }}</h1>
            </div>
            <div class="row my-row no-gutters">
                <div class="col-sm-10">
                    <div class="card-body">
                        <app-error [error_message]="errorMessage" [error_type]="errorType"></app-error>
                        <div *ngIf="ref != ''" class="alert alert-warning alert-dismissible fade show" role="alert">
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            {{ 'OTP.PATIENT-INFO' | translate }}
                        </div>
                        <div class="mt-2">
                            <form [formGroup]="otpForm" autocomplete="off" novalidate (ngSubmit)="validateOtp(otpForm.value)">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="{{ 'OTP.CODE-OTP' | translate }}" formControlName="otpCode" id="otpCode" autofocus>
                                    <mat-error *ngIf="hasError('otpCode', 'required')">{{ "ERRORS.OTP-REQUIRED" | translate }}</mat-error>
                                </div>
                                <div class="form-group mt-3">
                                    <button type="button" class="btn btn-outline-primary mr-4" (click)='sendAgain()'>{{ "BUTTONS.RESEND-OTP" | translate }}</button>
                                    <button type="submit" class="btn btn-primary" [disabled]="!otpForm.valid">{{ "BUTTONS.VALIDATE" | translate }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
